import { render, staticRenderFns } from "./_memberProfile.vue?vue&type=template&id=9d4d0d4c&scoped=true&lang=pug&"
import script from "./_memberProfile.vue?vue&type=script&lang=js&"
export * from "./_memberProfile.vue?vue&type=script&lang=js&"
import style0 from "./_memberProfile.vue?vue&type=style&index=0&id=9d4d0d4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d4d0d4c",
  null
  
)

export default component.exports